// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"57":"swiper-css","979":"swiper"}[chunkId] + ".js";
};